import { Network } from '@capacitor/network';
import * as webNetwork from './web';

let connected = webNetwork.isOnline();
export const isOnline = () => connected;
export const getStatus = async () => {
    try {
        const status = await Network.getStatus();
        connected = status.connected;
        return status;
    } catch { return { connected: webNetwork.isOnline() }; }
};

// Keep the synchronous unsubscribe contract used by the web adapter.
export const onChange = callback => {
    let active = true;
    const listener = Network.addListener('networkStatusChange', status => {
        connected = status.connected;
        if (active) callback(status);
    });
    void listener.catch(() => {});
    return () => {
        active = false;
        void listener.then(handle => handle.remove()).catch(() => {});
    };
};
